import { ContactsSubscribeWUT } from '@wix/form-fields/wut';

export default ContactsSubscribeWUT;
